import {
  LinkedHashSetClassDesc202cqq5740j6e as LinkedHashSetClassDesc,
  ArrayListClassDesc2euexqfjnihq7 as ArrayListClassDesc,
  HashSetClassDesc1sva99tssxbb4 as HashSetClassDesc,
  HashMapClassDesc33bep136pd9y6 as HashMapClassDesc,
  LinkedHashMapClassDesc1yxtovbec4ruk as LinkedHashMapClassDesc,
  ArrayClassDesc2voesact8ugbc as ArrayClassDesc,
  PrimitiveArrayDescriptor3bvg9e2uulc3b as PrimitiveArrayDescriptor,
} from './CollectionDescriptors.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtSetjrjc7fhfd6b9 as KtSet,
  KtList3hktaavzmj137 as KtList,
  KtMap140uvy3s5zad8 as KtMap,
  Collection1k04j3hzsbod0 as Collection,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { arrayIterator3lgwvgteckzhv as arrayIterator } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { toNativeArrayImpl3ha7yn5cjhfpi as toNativeArrayImpl } from './Platform.mjs';
import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { PrimitiveKindndgbuh6is7ze as PrimitiveKind } from '../descriptors/SerialKinds.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var LinkedHashSetSerializerClass;
function LinkedHashSetSerializer() {
  if (LinkedHashSetSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(eSerializer) {
        super(eSerializer);
        this.a1u_1 = new (LinkedHashSetClassDesc())(eSerializer.h1m());
      }
      h1m() {
        return this.a1u_1;
      }
      b1u() {
        // Inline function 'kotlin.collections.linkedSetOf' call
        return LinkedHashSet().s2();
      }
      c1u(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      d1u(_this__u8e3s4) {
        return this.c1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      e1u(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      f1u(_this__u8e3s4) {
        return this.e1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      g1u(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? LinkedHashSet().c3(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      h1u(_this__u8e3s4) {
        return this.g1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      i1u(_this__u8e3s4, size) {
      }
      j1u(_this__u8e3s4, size) {
        return this.i1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      k1u(_this__u8e3s4, index, element) {
        _this__u8e3s4.i2(element);
      }
      l1u(_this__u8e3s4, index, element) {
        return this.k1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'LinkedHashSetSerializer');
    LinkedHashSetSerializerClass = $;
  }
  return LinkedHashSetSerializerClass;
}
var ArrayListSerializerClass;
function ArrayListSerializer() {
  if (ArrayListSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(element) {
        super(element);
        this.w1u_1 = new (ArrayListClassDesc())(element.h1m());
      }
      h1m() {
        return this.w1u_1;
      }
      b1u() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList().p2();
      }
      x1u(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      d1u(_this__u8e3s4) {
        return this.x1u(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      y1u(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      f1u(_this__u8e3s4) {
        return this.y1u(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      z1u(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? ArrayList().j2(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      h1u(_this__u8e3s4) {
        return this.z1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      a1v(_this__u8e3s4, size) {
        return _this__u8e3s4.h8(size);
      }
      j1u(_this__u8e3s4, size) {
        return this.a1v(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      b1v(_this__u8e3s4, index, element) {
        _this__u8e3s4.b5(index, element);
      }
      l1u(_this__u8e3s4, index, element) {
        return this.b1v(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'ArrayListSerializer');
    ArrayListSerializerClass = $;
  }
  return ArrayListSerializerClass;
}
var HashSetSerializerClass;
function HashSetSerializer() {
  if (HashSetSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(eSerializer) {
        super(eSerializer);
        this.d1v_1 = new (HashSetClassDesc())(eSerializer.h1m());
      }
      h1m() {
        return this.d1v_1;
      }
      b1u() {
        return HashSet().ga();
      }
      e1v(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      d1u(_this__u8e3s4) {
        return this.e1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      f1v(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      f1u(_this__u8e3s4) {
        return this.f1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      g1u(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? HashSet().ha(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      h1u(_this__u8e3s4) {
        return this.g1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      g1v(_this__u8e3s4, size) {
      }
      j1u(_this__u8e3s4, size) {
        return this.g1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      h1v(_this__u8e3s4, index, element) {
        _this__u8e3s4.i2(element);
      }
      l1u(_this__u8e3s4, index, element) {
        return this.h1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'HashSetSerializer');
    HashSetSerializerClass = $;
  }
  return HashSetSerializerClass;
}
var HashMapSerializerClass;
function HashMapSerializer() {
  if (HashMapSerializerClass === VOID) {
    class $ extends MapLikeSerializer() {
      constructor(kSerializer, vSerializer) {
        super(kSerializer, vSerializer);
        this.k1v_1 = new (HashMapClassDesc())(kSerializer.h1m(), vSerializer.h1m());
      }
      h1m() {
        return this.k1v_1;
      }
      l1v(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      m1v(_this__u8e3s4) {
        return this.l1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      n1v(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.l3().p1();
      }
      o1v(_this__u8e3s4) {
        return this.n1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      b1u() {
        return HashMap().r8();
      }
      p1v(_this__u8e3s4) {
        return imul(_this__u8e3s4.q2(), 2);
      }
      d1u(_this__u8e3s4) {
        return this.p1v(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      q1v(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      f1u(_this__u8e3s4) {
        return this.q1v(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      r1v(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? HashMap().g9(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      h1u(_this__u8e3s4) {
        return this.r1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      s1v(_this__u8e3s4, size) {
      }
      j1u(_this__u8e3s4, size) {
        return this.s1v(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE(), size);
      }
    }
    initMetadataForClass($, 'HashMapSerializer');
    HashMapSerializerClass = $;
  }
  return HashMapSerializerClass;
}
var LinkedHashMapSerializerClass;
function LinkedHashMapSerializer() {
  if (LinkedHashMapSerializerClass === VOID) {
    class $ extends MapLikeSerializer() {
      constructor(kSerializer, vSerializer) {
        super(kSerializer, vSerializer);
        this.z1v_1 = new (LinkedHashMapClassDesc())(kSerializer.h1m(), vSerializer.h1m());
      }
      h1m() {
        return this.z1v_1;
      }
      l1v(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      m1v(_this__u8e3s4) {
        return this.l1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      n1v(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.l3().p1();
      }
      o1v(_this__u8e3s4) {
        return this.n1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      b1u() {
        return LinkedHashMap().bc();
      }
      a1w(_this__u8e3s4) {
        return imul(_this__u8e3s4.q2(), 2);
      }
      d1u(_this__u8e3s4) {
        return this.a1w(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      b1w(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      f1u(_this__u8e3s4) {
        return this.b1w(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      r1v(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? LinkedHashMap().dc(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      h1u(_this__u8e3s4) {
        return this.r1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      c1w(_this__u8e3s4, size) {
      }
      j1u(_this__u8e3s4, size) {
        return this.c1w(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE(), size);
      }
    }
    initMetadataForClass($, 'LinkedHashMapSerializer');
    LinkedHashMapSerializerClass = $;
  }
  return LinkedHashMapSerializerClass;
}
var ReferenceArraySerializerClass;
function ReferenceArraySerializer() {
  if (ReferenceArraySerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      constructor(kClass, eSerializer) {
        super(eSerializer);
        this.e1w_1 = kClass;
        this.f1w_1 = new (ArrayClassDesc())(eSerializer.h1m());
      }
      h1m() {
        return this.f1w_1;
      }
      g1w(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      m1v(_this__u8e3s4) {
        return this.g1w((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      h1w(_this__u8e3s4) {
        return arrayIterator(_this__u8e3s4);
      }
      o1v(_this__u8e3s4) {
        return this.h1w((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      b1u() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList().p2();
      }
      i1w(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      d1u(_this__u8e3s4) {
        return this.i1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      j1w(_this__u8e3s4) {
        return toNativeArrayImpl(_this__u8e3s4, this.e1w_1);
      }
      f1u(_this__u8e3s4) {
        return this.j1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      k1w(_this__u8e3s4) {
        return ArrayList().j2(asList(_this__u8e3s4));
      }
      h1u(_this__u8e3s4) {
        return this.k1w((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      l1w(_this__u8e3s4, size) {
        return _this__u8e3s4.h8(size);
      }
      j1u(_this__u8e3s4, size) {
        return this.l1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      m1w(_this__u8e3s4, index, element) {
        _this__u8e3s4.b5(index, element);
      }
      l1u(_this__u8e3s4, index, element) {
        return this.m1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'ReferenceArraySerializer');
    ReferenceArraySerializerClass = $;
  }
  return ReferenceArraySerializerClass;
}
var CollectionSerializerClass;
function CollectionSerializer() {
  if (CollectionSerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      n1u(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      m1v(_this__u8e3s4) {
        return this.n1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      o1u(_this__u8e3s4) {
        return _this__u8e3s4.p1();
      }
      o1v(_this__u8e3s4) {
        return this.o1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
    }
    initMetadataForClass($, 'CollectionSerializer');
    CollectionSerializerClass = $;
  }
  return CollectionSerializerClass;
}
var MapLikeSerializerClass;
function MapLikeSerializer() {
  if (MapLikeSerializerClass === VOID) {
    class $ extends AbstractCollectionSerializer() {
      constructor(keySerializer, valueSerializer) {
        super();
        this.t1v_1 = keySerializer;
        this.u1v_1 = valueSerializer;
      }
      v1v(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        if (!(size >= 0)) {
          var message = 'Size must be known in advance when using READ_ALL';
          throw IllegalArgumentException().n2(toString(message));
        }
        var progression = step(until(0, imul(size, 2)), 2);
        var inductionVariable = progression.q3_1;
        var last = progression.r3_1;
        var step_0 = progression.s3_1;
        if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + step_0 | 0;
            this.w1v(decoder, startIndex + index | 0, builder, false);
          }
           while (!(index === last));
      }
      r1u(decoder, builder, startIndex, size) {
        return this.v1v(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap()) : false) ? builder : THROW_CCE(), startIndex, size);
      }
      w1v(decoder, index, builder, checkIndex) {
        var key = decoder.l1r(this.h1m(), index, this.t1v_1);
        var tmp;
        if (checkIndex) {
          // Inline function 'kotlin.also' call
          var this_0 = decoder.p1r(this.h1m());
          // Inline function 'kotlin.require' call
          if (!(this_0 === (index + 1 | 0))) {
            var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
            throw IllegalArgumentException().n2(toString(message));
          }
          tmp = this_0;
        } else {
          tmp = index + 1 | 0;
        }
        var vIndex = tmp;
        var tmp_0;
        var tmp_1;
        if (builder.s4(key)) {
          var tmp_2 = this.u1v_1.h1m().d1p();
          tmp_1 = !(tmp_2 instanceof PrimitiveKind());
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = decoder.k1r(this.h1m(), vIndex, this.u1v_1, getValue(builder, key));
        } else {
          tmp_0 = decoder.l1r(this.h1m(), vIndex, this.u1v_1);
        }
        var value = tmp_0;
        // Inline function 'kotlin.collections.set' call
        builder.x4(key, value);
      }
      s1u(decoder, index, builder, checkIndex) {
        return this.w1v(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap()) : false) ? builder : THROW_CCE(), checkIndex);
      }
      q1u(encoder, value) {
        var size = this.m1v(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.h1m();
        var composite = encoder.v1s(descriptor, size);
        var iterator = this.o1v(value);
        var index = 0;
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = iterator;
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          // Inline function 'kotlin.collections.component1' call
          var k = element.m3();
          // Inline function 'kotlin.collections.component2' call
          var v = element.n3();
          var tmp = this.h1m();
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          composite.q1s(tmp, _unary__edvuaz, this.t1v_1, k);
          var tmp_0 = this.h1m();
          var _unary__edvuaz_0 = index;
          index = _unary__edvuaz_0 + 1 | 0;
          composite.q1s(tmp_0, _unary__edvuaz_0, this.u1v_1, v);
        }
        composite.z1q(descriptor);
      }
      i1m(encoder, value) {
        return this.q1u(encoder, value);
      }
    }
    initMetadataForClass($, 'MapLikeSerializer');
    MapLikeSerializerClass = $;
  }
  return MapLikeSerializerClass;
}
var CollectionLikeSerializerClass;
function CollectionLikeSerializer() {
  if (CollectionLikeSerializerClass === VOID) {
    class $ extends AbstractCollectionSerializer() {
      constructor(elementSerializer) {
        super();
        this.p1u_1 = elementSerializer;
      }
      q1u(encoder, value) {
        var size = this.m1v(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.h1m();
        var composite = encoder.v1s(descriptor, size);
        var iterator = this.o1v(value);
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            composite.q1s(this.h1m(), index, this.p1u_1, iterator.r1());
          }
           while (inductionVariable < size);
        composite.z1q(descriptor);
      }
      i1m(encoder, value) {
        return this.q1u(encoder, value);
      }
      r1u(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        if (!(size >= 0)) {
          var message = 'Size must be known in advance when using READ_ALL';
          throw IllegalArgumentException().n2(toString(message));
        }
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.s1u(decoder, startIndex + index | 0, builder, false);
          }
           while (inductionVariable < size);
      }
      s1u(decoder, index, builder, checkIndex) {
        this.l1u(builder, index, decoder.l1r(this.h1m(), index, this.p1u_1));
      }
    }
    initMetadataForClass($, 'CollectionLikeSerializer');
    CollectionLikeSerializerClass = $;
  }
  return CollectionLikeSerializerClass;
}
function readSize($this, decoder, builder) {
  var size = decoder.q1r($this.h1m());
  $this.j1u(builder, size);
  return size;
}
var AbstractCollectionSerializerClass;
function AbstractCollectionSerializer() {
  if (AbstractCollectionSerializerClass === VOID) {
    class $ {
      u1u(decoder, previous) {
        var tmp1_elvis_lhs = previous == null ? null : this.h1u(previous);
        var builder = tmp1_elvis_lhs == null ? this.b1u() : tmp1_elvis_lhs;
        var startIndex = this.d1u(builder);
        var compositeDecoder = decoder.y1q(this.h1m());
        if (compositeDecoder.o1r()) {
          this.r1u(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
        } else {
          $l$loop: while (true) {
            var index = compositeDecoder.p1r(this.h1m());
            if (index === -1)
              break $l$loop;
            this.t1u(compositeDecoder, startIndex + index | 0, builder);
          }
        }
        compositeDecoder.z1q(this.h1m());
        return this.f1u(builder);
      }
      j1m(decoder) {
        return this.u1u(decoder, null);
      }
      t1u(decoder, index, builder, checkIndex, $super) {
        checkIndex = checkIndex === VOID ? true : checkIndex;
        var tmp;
        if ($super === VOID) {
          this.s1u(decoder, index, builder, checkIndex);
          tmp = Unit_instance;
        } else {
          tmp = $super.s1u.call(this, decoder, index, builder, checkIndex);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer()]);
    AbstractCollectionSerializerClass = $;
  }
  return AbstractCollectionSerializerClass;
}
var PrimitiveArraySerializerClass;
function PrimitiveArraySerializer() {
  if (PrimitiveArraySerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      constructor(primitiveSerializer) {
        super(primitiveSerializer);
        this.o1w_1 = new (PrimitiveArrayDescriptor())(primitiveSerializer.h1m());
      }
      h1m() {
        return this.o1w_1;
      }
      p1w(_this__u8e3s4) {
        return _this__u8e3s4.q1w();
      }
      d1u(_this__u8e3s4) {
        return this.p1w(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE());
      }
      r1w(_this__u8e3s4) {
        return _this__u8e3s4.s1w();
      }
      f1u(_this__u8e3s4) {
        return this.r1w(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE());
      }
      t1w(_this__u8e3s4, size) {
        return _this__u8e3s4.u1w(size);
      }
      j1u(_this__u8e3s4, size) {
        return this.t1w(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      v1w(_this__u8e3s4) {
        // Inline function 'kotlin.error' call
        var message = 'This method lead to boxing and must not be used, use writeContents instead';
        throw IllegalStateException().o(toString(message));
      }
      o1v(_this__u8e3s4) {
        return this.v1w(_this__u8e3s4);
      }
      w1w(_this__u8e3s4, index, element) {
        // Inline function 'kotlin.error' call
        var message = 'This method lead to boxing and must not be used, use Builder.append instead';
        throw IllegalStateException().o(toString(message));
      }
      l1u(_this__u8e3s4, index, element) {
        return this.w1w(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
      b1u() {
        return this.h1u(this.x1w());
      }
      a1x(encoder, value) {
        var size = this.m1v(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.o1w_1;
        var composite = encoder.v1s(descriptor, size);
        this.z1w(composite, value, size);
        composite.z1q(descriptor);
      }
      i1m(encoder, value) {
        return this.a1x(encoder, value);
      }
      q1u(encoder, value) {
        return this.a1x(encoder, value);
      }
      j1m(decoder) {
        return this.u1u(decoder, null);
      }
    }
    initMetadataForClass($, 'PrimitiveArraySerializer');
    PrimitiveArraySerializerClass = $;
  }
  return PrimitiveArraySerializerClass;
}
var PrimitiveArrayBuilderClass;
function PrimitiveArrayBuilder() {
  if (PrimitiveArrayBuilderClass === VOID) {
    class $ {
      b1x(requiredCapacity, $super) {
        requiredCapacity = requiredCapacity === VOID ? this.q1w() + 1 | 0 : requiredCapacity;
        var tmp;
        if ($super === VOID) {
          this.u1w(requiredCapacity);
          tmp = Unit_instance;
        } else {
          tmp = $super.u1w.call(this, requiredCapacity);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'PrimitiveArrayBuilder');
    PrimitiveArrayBuilderClass = $;
  }
  return PrimitiveArrayBuilderClass;
}
//region block: exports
export {
  ArrayListSerializer as ArrayListSerializer7k5wnrulb3y6,
  HashMapSerializer as HashMapSerializer10v33y6rrzgrh,
  HashSetSerializer as HashSetSerializer1nieavib0jif1,
  LinkedHashMapSerializer as LinkedHashMapSerializermaoj2nyji7op,
  LinkedHashSetSerializer as LinkedHashSetSerializer3ncla559t2lx7,
  PrimitiveArrayBuilder as PrimitiveArrayBuilder1tzna3i4eqw54,
  PrimitiveArraySerializer as PrimitiveArraySerializer6xcmeltdozbx,
  ReferenceArraySerializer as ReferenceArraySerializer3juj1vqolxkrs,
};
//endregion

//# sourceMappingURL=CollectionSerializers.mjs.map
